import { render, staticRenderFns } from "./ScrollColumn.vue?vue&type=template&id=76753d74&scoped=true&"
import script from "./ScrollColumn.vue?vue&type=script&lang=js&"
export * from "./ScrollColumn.vue?vue&type=script&lang=js&"
import style0 from "./ScrollColumn.vue?vue&type=style&index=0&id=76753d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76753d74",
  null
  
)

export default component.exports